"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpmMessageService = void 0;
const insights_client_library_1 = __importStar(require("@eccr-cuttingedge/insights-client-library"));
const superstruct_1 = require("superstruct");
const IpmDownloader_1 = require("./IpmDownloader");
const utils_1 = require("./utils");
const InsightsClientExtended_1 = require("./InsightsClientExtended");
class IpmMessageService {
    constructor(context) {
        this.context = context;
        const { env } = context.analytics.contextService.context.config;
        const envMapping = {
            dev: insights_client_library_1.ENV.STAGE,
            stg: insights_client_library_1.ENV.STAGE,
            prd: insights_client_library_1.ENV.PRODUCTION,
        };
        this.client = new InsightsClientExtended_1.InsightsClientExtended(new insights_client_library_1.default({
            // Service subscription callback
            callback() {
                throw new Error("Not implemented");
            },
            getAccessToken() {
                var _a;
                const userToken = (_a = context.analytics.contextService.context.tokenInfo) === null || _a === void 0 ? void 0 : _a.userToken;
                if (!userToken) {
                    return Promise.reject(new Error("Insights service is not available for unnamed user"));
                }
                return Promise.resolve(`Bearer ${userToken}`);
            },
        }, envMapping[env]));
        this.ipmDownloader = new IpmDownloader_1.IpmDownloader(this.client);
    }
    getMessage(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.client.getInsight(filter)).data.insight;
        });
    }
    getMessages(filter) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.client.getInsights(filter)).data.insights;
        });
    }
    submitMessage(insight) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.client.submitInsight(insight);
        });
    }
    getRulesEngines() {
        return __awaiter(this, void 0, void 0, function* () {
            const product = (0, utils_1.productLineCodeFrom)(this.context.analytics);
            const version = (0, utils_1.productVersionFrom)(this.context.analytics);
            (0, superstruct_1.assert)(product, (0, superstruct_1.nonempty)((0, superstruct_1.string)()), "ADP Web SDK needs to be initialized with product line code (product.line_name)");
            (0, superstruct_1.assert)(version, (0, superstruct_1.nonempty)((0, superstruct_1.string)()), "ADP Web SDK needs to be initialized with product version (product.build_id)");
            return this.ipmDownloader.buildRuleEngines({ product, version });
        });
    }
    subscribe() {
        /** @todo subscribe to insights service */
        return Promise.reject(new Error("Not implemented"));
    }
}
exports.IpmMessageService = IpmMessageService;
